import { ff } from '@atlassian/jira-feature-flagging';
import { fg } from '@atlassian/jira-feature-gating';
import { CLICK_UP } from '../../../constants/import-type';
import {
	DEFAULT_CONFIG,
	type StepComponent,
	UPLOAD_CSV_STEP,
	IMPORT_IN_PROGRESS_STEP,
	PROJECT_CREATE_STEP,
	SELECT_THIRD_PARTY_ENTITY_STEP,
	StatisticsType,
	THIRD_PARTY_REVIEW_STEP,
	ReviewTilesType,
	SELECT_SOURCE_STEP,
} from '../../../constants/steps';
import commonMessages from '../messages';
import messages from './messages';

export const getClickUpSteps = (): StepComponent[] => [
	{
		step: SELECT_THIRD_PARTY_ENTITY_STEP,
		overrides: {
			overrideReturnStep: fg('enable-x2c-standardised-flow') ? SELECT_SOURCE_STEP : UPLOAD_CSV_STEP,
		},
		stepProps: {
			thirdParty: CLICK_UP,
			stats: [StatisticsType.TASKS],
			shouldShowSpaceSelector: true,
			shouldShowFolderSelector: true,
			isMultipleEntitiesSupported: ff('x2c-clickup-importer-multi-list'),
		},
		progressBarStepLabel: messages.clickupStepLabel,
	},
	{
		...DEFAULT_CONFIG,
		step: PROJECT_CREATE_STEP,
		stepProps: {
			hasProgressBar: true,
			shouldPrefillThirdPartyProjectName: true,
			shouldShowThirdPartyStats: false,
			thirdParty: CLICK_UP,
			shouldStartImportOnNext: false,
			isTMPSupported: true,
			templates: [],
		},
		progressBarStepLabel: commonMessages.projectCreateStepLabel,
	},
	{
		...DEFAULT_CONFIG,
		step: THIRD_PARTY_REVIEW_STEP,
		stepProps: {
			thirdParty: CLICK_UP,
			isMultipleEntitiesSupported: ff('x2c-clickup-importer-multi-list'),
			tiles: ff('x2c-clickup-importer-multi-list')
				? [
						ReviewTilesType.HIERARCHY,
						ReviewTilesType.STATUS,
						ReviewTilesType.FIELDS,
						ReviewTilesType.USERS,
						ReviewTilesType.ATTACHMENTS,
						ReviewTilesType.COMMENTS,
					]
				: [
						ReviewTilesType.HIERARCHY,
						ReviewTilesType.FIELDS,
						ReviewTilesType.USERS,
						ReviewTilesType.ATTACHMENTS,
						ReviewTilesType.COMMENTS,
					],
		},
		progressBarStepLabel: commonMessages.reviewStepLabel,
	},
	{
		step: IMPORT_IN_PROGRESS_STEP,
		overrides: {
			overrideReturnStep: fg('enable-x2c-standardised-flow') ? SELECT_SOURCE_STEP : UPLOAD_CSV_STEP,
		},
		stepProps: {
			hasProgressBar: true,
			thirdParty: CLICK_UP,
		},
		progressBarStepLabel: commonMessages.importInProgressStepLabel,
	},
];
